import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component({selector: 'reset-password-dialog', templateUrl: './reset-password-dialog.html'})
export class ResetPasswordDialogComponent {
  	email = new FormControl('', [
		Validators.pattern(
			'^[a-z0-9!#$%&\'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$'),
		Validators.required
  	]);

  	constructor(
	  	public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
	  	@Inject(MAT_DIALOG_DATA) public data: any) {}

  	getErrorMessage() {
		return this.email.hasError('required') ?
			'You must enter an email' :
			this.email.hasError('pattern') ? 'Not a valid email' : '';
  	}

  	onNoClick(): void {
		this.dialogRef.close();
  	}
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/login/reset/reset-password.dialog.component.ts